import { ArrowUpRight, CheckCircle } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom';

function BusinessTaxation() {
  const faqData = [
    {
      title: "Revenue",
      items: [
        "Sale, Fees, Commissions",
        "Commissions as per T4A (Self-employed)",
        "COST OF GOODS SOLD",
        "Opening inventory",
        "Purchases during the year",
        "Subcontracts and direct wages",
        "Ending inventory",
      ],
    },
    {
      title: "Automobile Expenses",
      items: [
        "Total Kms/Miles driven during the year",
        "Kms for business use",
        "Auto Gas/Fuel",
        "Auto Repairs and maintenance",
        "Auto Parking",
        "Insurance",
        "Auto loan interest",
        "Leasing costs",
        "All other expenses related to automobile",
      ],
    },
    {
      title: "Expenses",
      items: [
        "Legal papers of buying equipment & vehicles used in your business",
        "Utilities & Telephone bills",
        "Property taxes",
        "Rent/mortgage papers (payment + interest paid)",
        "Insurance",
        "Advertising & Promotion",
        "Business tax, fees, licenses, dues & memberships",
        "Delivery and freight charges",
        "Office & Supplies expenses",
        "Salaries and wages",
        "Travel Expenses",
        "Meals and Entertainment"
      ],
    },
    
    {
      title: "Home Office Cost",
      items: [
        "Space used for business",
        "Sq. Ft. of Home for business use",
        "Mortgage interest (Need Mortgage Statement)",
        "Rent (If renting)",
        "Utilities (Heat, Hydro, Water)",
        "Condominium fees",
        "Property taxes (Need Actual Bill)",
        "OTHER: Please bring the previous year's financial statements and tax return copies along with the company's articles."
      ],
    }
    
  ];

  return (
    <div>
       {/* Hero Section */}
       <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/businesstaxation2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
          <h1 className="text-4xl font-bold mb-4 md:text-8xl">Business  Taxation </h1>
          <p className="text-lg max-w-3xl text-gray-400 md:text-3xl">
          Effortless tax management for a secure and prosperous financial future!
          </p>
        </div>
      </section>


      <div className="flex flex-col items-center text-center gap-12 bg-slate-900 py-12 px-6 md:px-16">
  <h2 className="text-4xl md:text-6xl font-bold text-gray-100">
  Business Tax Filing
  </h2>

  <p className="text-2xl max-w-5xl text-justify text-gray-400  mx-auto">
  We offer expert business tax services to help you optimize deductions, ensure compliance, and minimize tax liabilities.  
    Our team provides accurate tax preparation, stays updated with the latest regulations, and delivers strategic planning  
    tailored to your business needs. Whether you're a small startup or an established company, we streamline the tax filing  
    process, so you can focus on growing your business with confidence. 
  </p>

  <div className="flex mt-3 justify-center">
                                 <Link to="/contactus">
    <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
      Schedule A Call
      <ArrowUpRight size={20} />
    </button></Link>
  </div>
</div>

<div className="max-w-3xl mx-auto p-6">
      {faqData.map((faq, index) => (
        <div key={index} className="border-b border-gray-300 pb-4 mb-4">
          <h2 className=" text-3xl md:text-4xl font-semibold text-gray-900">{faq.title}</h2>
          <ul className="mt-2 space-y-2">
            {faq.items.map((item, i) => (
              <li key={i} className="flex text-xl mt-6 items-center text-gray-700">
                <CheckCircle className="w-5 h-5 text-gray-500 mr-2" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    </div>
  )
}

export default BusinessTaxation